import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const TransferredCases = lazy(() => import('./TransferredCases.jsx'))
const TransferredCaseDetails = lazy(() => import('./CaseDetailsView.jsx'))

const TransferredCasesRoutes = [
    {
        path: '/TransferredCases',
        component: TransferredCases,
        auth: authRoleAccess.org_head_case_management,
    },
    {
        path: '/transferred-cases/:id',
        component: TransferredCaseDetails,
        auth: authRoleAccess.org_head_case_management,
    },
]

export default TransferredCasesRoutes
